import React from 'react';
import styled from 'styled-components';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

import { useDebriefApp } from 'ff/debrief/hooks';
import ScoreIcon from 'ff/debrief/components/customIcons/ScoreIcon';

const HideSegmentDetailsButton = () => {
    const { isHidingSegmentDetails, hideScoreDetails, showScoreDetails } =
        useDebriefApp();

    const handleClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            showScoreDetails();
        } else {
            hideScoreDetails();
        }
    };

    return (
        <Box
            sx={{
                ml: 1,
                px: 1,
                py: 0.5,
                height: '32px',
                borderRadius: '4px',
                display: 'inline-block',
                backgroundColor: '#FFFFFF',
                boxShadow:
                    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
            }}
        >
            <Stack direction="row" alignItems="center">
                <ScoreIcon sx={{ height: '24px', width: '19px' }} />
                <Label ml={1}>Off</Label>
                <Switch
                    onChange={handleClick}
                    checked={!isHidingSegmentDetails}
                    size="small"
                ></Switch>
                <Label ml={0}>On</Label>
            </Stack>
        </Box>
    );
};

const Label = styled(Typography)`
    font-size: 13px;
    color: #646468;
`;

export default HideSegmentDetailsButton;
